import '.l{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.az{align-items:stretch;}.ssr-plugin'
import '.b0{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.b1{border-radius:1.25rem;}.ssr-plugin'
import '.b2{background-color:var(--palette-white);}.ssr-plugin'
import '.be{overflow-y:auto;}.ssr-plugin'
import '.bf{height:98dvh;}.ssr-plugin'
import '.bg{width:98vw;}.ssr-plugin'
import '.bh{overflow-y:hidden;}.ssr-plugin'
import '.aw{height:min(50rem, 90vh);}.ssr-plugin'
import { styled } from 'inlines'
import { Authentication } from '../authentication/Authentication'
import { ModalWrapper } from './ModalWrapper'
import { AuthTab } from '../authentication/authTabs'
import useMediaQuery from '@app/util/useMediaQuery'

export type AuthModalProps = {
  isOpen: boolean
  tab: AuthTab
  onClose: (setUtm?: boolean) => void
  verificationTab?: AuthTab | null
}

export const AuthModal = ({
  isOpen,
  tab,
  onClose,
  verificationTab,
}: AuthModalProps) => {
  const isMobile = useMediaQuery()

  if (!isOpen) {
    return null
  }

  if (isMobile) {
    return (
      <ModalWrapper>
        <div className="l m az b0 b1 b2 be bf bg"
        >
          <Authentication
            tab={tab}
            onClose={onClose}
            verificationTab={verificationTab}
          />
        </div>
      </ModalWrapper>
    )
  }

  return (
    <ModalWrapper>
      <div className="l m az b0 b1 b2 bh aw"
        style={{
          maxWidth: isMobile ? '90vw' : 'var(--max-width-modal)',}}
      >
        <Authentication
          tab={tab}
          onClose={onClose}
          verificationTab={verificationTab}
        />
      </div>
    </ModalWrapper>
  )
}
